import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from '../../material-modules/angular-material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { LegendTableComponent } from './legend-table/legend-table.component';
import { PermissionViewTableByProgramComponent } from './permission-view-table-by-program/permission-view-table-by-program.component';

@NgModule({
  declarations: [PermissionViewTableByProgramComponent, LegendTableComponent],
  imports: [
    CommonModule,
    PipesModule,
    AngularMaterialModule,
    TranslateModule,
  ],
  exports: [PermissionViewTableByProgramComponent, LegendTableComponent],
})
export class PermissionViewerModule { }
